import { Component, Input } from '@angular/core';
import { ForkliftRouteDetailDto } from '@shared/src/dtos/accesscontrol/forklift/ForkliftRouteDetailDto';

@Component({
    selector: 'shared-forklift-right-route-header',
    templateUrl: './shared.forklift.right.route.header.component.html',
    styleUrls: ['./shared.forklift.right.route.header.component.scss']
})
export class SharedForkliftRightRouteHeaderComponent {

    @Input() public detail: ForkliftRouteDetailDto | null = null;

    public get phoneHref(): string | null {
        if (!this.detail?.driverPhone)
            return null;
        return 'tel:' + this.detail.driverPhone;
    }

    public get smsHref(): string | null {
        if (!this.detail?.driverPhone)
            return null;
        return 'sms:' + this.detail.driverPhone;
    }
}
